export default {
  title: 'Submit changes',
  subTitleStart: 'Do you want to unlock ',
  subTitleEnd: '?',
  buttonCancel: 'Cancel',
  buttonSubmit: 'Submit',
};
